import { Eye, EyeSlash } from "@phosphor-icons/react";
import { Button, Size, Variant } from "../../../components/Buttons";
import { IconButton } from "../../../components/Buttons/IconButton";
import { Form } from "../../../components/Form";
import { TextField } from "../../../components/Form/Fields/TextField";
import { useLoginController } from "../../../controllers/loginController";

export const Login = () => {
  const {
    form: {
      register,
      formState: {
        errors,
      }
    },
    fieldShowValue,
    handleSubmit,
    toggleFieldShowValue,
  } = useLoginController();

  return (
    <Form onSubmit={ handleSubmit }>
      <div className="inputs-view">
        <TextField
          registerProps={ register("email")}
          label="Email"
          placeholder="Email"
          error={ errors.email }
          type="email"
          autoComplete="username"
        />

        <TextField
          registerProps={ register("password")}
          label="Senha"
          placeholder="Senha"
          error={ errors.password }
          autoComplete="current-password"
          showPassword={ fieldShowValue.password }
          endAdornment={(
            <IconButton
              color="text"
              onClick={() => toggleFieldShowValue("password")}
              aria-label={ fieldShowValue.password ? "Ocultar senha" : "Mostrar senha" }
              aria-pressed={ fieldShowValue.password }
            >
              {
                fieldShowValue.password
                  ? <EyeSlash />
                  : <Eye />
              }
            </IconButton>
          )}
        />
      </div>

      <div
        className="actions-view"
      >
        <Button
          disabled={ false }
          type="submit"
          $variant={ Variant.CONTAINED }
          $color="text"
          $size={ Size.LARGE }
        >
          Entrar
        </Button>
      </div>
    </Form>
  );
};
